import { useEffect, useState } from "react"

const useAdmin = email => {
    const [isAdmin, setIsadmin] = useState(false)
    const [isAdminLoading, setIsadminLoading] = useState(true)
    useEffect(() => {
        if (email) {
            fetch(`https://denticare-server-sumonhasan55.vercel.app/users/admin/${email}`)
                .then(res => res.json())
                .then(data => {
                    setIsadmin(data.isAdmin)
                    setIsadminLoading(false)
                })
        }

    }, [email])
    return [isAdmin,isAdminLoading]
}
export default useAdmin;